import Joi from "joi";
import errorsResolver from "../schemeUtils";

const messageLength = 300;

export const messageModalScheme = Joi.object({
    message: Joi.string()
    .required()
    .max(messageLength)
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\\\(*/?!%<>,-.|№")_=&$:;#~+@\' \\n\\r]*$'))
    .error(errorsResolver({
        required: `Сообщение обязательное поле`,
        max: `Длина сообщения должна быть меньше или равна ${messageLength} символам`,
        pattern: `Сообщение содержит некорректные символы`,
    })),
});
